var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import DayCell from './DayCell';
import cxs from 'cxs';
var styles = {
    row: cxs({
        borderBottom: '1px solid #dee2e6'
    }),
    experienceCell: cxs({
        padding: '12px',
        verticalAlign: 'top',
        position: 'sticky',
        left: 0,
        backgroundColor: '#fff',
        zIndex: 5,
        borderRight: '1px solid #dee2e6',
        minWidth: '200px',
        maxWidth: '200px'
    }),
    experienceName: cxs({
        fontSize: '0.9rem',
        fontWeight: 600,
        color: '#333',
        lineHeight: 1.3,
        wordBreak: 'break-word'
    }),
    experienceCapacity: cxs({
        fontSize: '0.75rem',
        color: '#6c757d',
        marginTop: '4px'
    }),
    colorIndicator: cxs({
        width: '12px',
        height: '12px',
        borderRadius: '3px',
        display: 'inline-block',
        marginRight: '8px',
        verticalAlign: 'middle',
        border: '1px solid rgba(0,0,0,0.15)'
    }),
    dayCell: cxs({
        padding: '8px',
        verticalAlign: 'top',
        borderRight: '1px solid #eee',
        minWidth: '140px'
    })
};
var StretchRow = /** @class */ (function (_super) {
    __extends(StretchRow, _super);
    function StretchRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StretchRow.prototype.render = function () {
        var _a = this.props, experience = _a.experience, dateRange = _a.dateRange, slotsByDate = _a.slotsByDate, onSlotClick = _a.onSlotClick;
        return (React.createElement("tr", { className: styles.row },
            React.createElement("td", { className: styles.experienceCell },
                React.createElement("div", { className: styles.experienceName },
                    React.createElement("span", { className: styles.colorIndicator, style: { backgroundColor: experience.color } }),
                    experience.name),
                React.createElement("div", { className: styles.experienceCapacity },
                    "Capacidad: ",
                    experience.defaultCapacity,
                    " plazas")),
            dateRange.map(function (date) {
                var dateStr = date.format('YYYY-MM-DD');
                var slots = slotsByDate[dateStr] || [];
                return (React.createElement("td", { key: dateStr, className: styles.dayCell },
                    React.createElement(DayCell, { slots: slots, experienceColor: experience.color, onSlotClick: onSlotClick })));
            })));
    };
    StretchRow = __decorate([
        observer
    ], StretchRow);
    return StretchRow;
}(Component));
export default StretchRow;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/components/StretchRow.tsx
// module id = 1610
// module chunks = 0